import React from "react";

export const AppContext = React.createContext(null);

export const withAppContext = Component => props => (
  <AppContext.Consumer>
    { appContext => <Component {...props} app={appContext} /> }
  </AppContext.Consumer>
);
